import React, { useEffect } from "react";
import Navigation from "../navigation/mainNavBar";

import "./Policy.scss";

import Footer from "../footer/Footer";

function Policy() {

  useEffect(() => {
    const sectionOffset = document.querySelector('section:first-of-type').offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="Policy">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">Polityka Prywatności</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          Jesteśmy WildLandsRP („my”, „nasz”, „nas”). Zależy nam na ochronie i
          poszanowaniu Twojej prywatności. Jeśli masz pytania dotyczące Twoich
          danych osobowych, skontaktuj się z nami.
          <h3>I. Jakie informacje o Tobie posiadamy?</h3>
          Rodzaj danych, które zbieramy i przetwarzamy, obejmuje:
          <ul>
            <li>Twój adres email</li>
            <li>Twój adres IP</li>
          </ul>
          Dalsze dane mogą być gromadzone, jeśli zdecydujesz się je udostępnić,
          na przykład jeśli wypełnisz pola w swoim profilu. <br />
          <br />
          Niektóre lub wszystkie z tych informacji gromadzimy w następujących
          przypadkach:
          <ul>
            <li>Rejestrujesz się jako członek na tej stronie</li>
            <li>Wypełniasz nasz formularz kontaktowy</li>
            <li>Wypełniasz pola w swoim profilu</li>
          </ul>
          <h3>II. Jak wykorzystywane są Twoje dane osobowe?</h3>
          Możemy wykorzystywać Twoje dane osobowe w następujący sposób:
          <ul>
            <li>
              W celu uczynienia Cię zarejestrowanym członkiem naszej witryny,
              abyś mógł wnosić treści do tej witryny
            </li>
            <li>
              Możemy użyć Twojego adresu e-mail, aby poinformować Cię o
              aktywności na naszej stronie
            </li>
            <li>
              Twój adres IP jest rejestrowany, gdy wykonujesz określone
              czynności na naszej stronie
            </li>
            <li>Twój adres IP nigdy nie jest publicznie widoczny</li>
          </ul>
          <h3>
            III. Inne sposoby, w jakie możemy wykorzystywać Twoje dane osobowe.
          </h3>
          W trakcie interakcji z naszą witryną możemy zbierać informacje, które
          nie umożliwiają identyfikacji użytkownika. Informacje te mogą
          obejmować informacje techniczne dotyczące przeglądarki lub typu
          urządzenia, z którego korzystasz. Informacje te będą wykorzystywane
          wyłącznie do celów analitycznych i śledzenia liczby odwiedzających
          naszą witrynę.
          <h3>IV. Dbanie o bezpieczeństwo Twoich danych.</h3>
          Dokładamy wszelkich starań, aby wszelkie informacje, które nam
          przekazujesz, były bezpieczne. Aby zapobiec nieautoryzowanemu
          dostępowi lub ujawnieniu, wprowadziliśmy odpowiednie środki i
          procedury w celu zabezpieczenia i zabezpieczenia gromadzonych przez
          nas informacji.
          <h3>V. Polityka Cookie.</h3>
          Pliki cookie to małe pliki tekstowe, które są umieszczane przez nas na
          Twoim komputerze, które umożliwiają nam zapewnienie określonych
          funkcji na naszej stronie, takich jak możliwość zalogowania się lub
          zapamiętywanie określonych preferencji.
          <h3>VI. Prawa</h3>
          Masz prawo dostępu do danych osobowych, które posiadamy na Twój temat
          lub uzyskania ich kopii. W tym celu prosimy o kontakt. Jeśli uważasz,
          że informacje, które posiadamy dla Ciebie są niekompletne lub
          niedokładne, możesz skontaktować się z nami, aby poprosić nas o
          uzupełnienie lub poprawienie tych informacji.
          <br />
          <br />
          Przysługuje Ci również prawo żądania usunięcia Twoich danych
          osobowych. Skontaktuj się z nami, jeśli chcesz, abyśmy usunęli Twoje
          dane osobowe.
          <h3>VII. Akceptacja tej polityki</h3>
          Dalsze korzystanie z naszej strony oznacza akceptację tej polityki.
          Jeśli nie akceptujesz polityki, nie korzystaj z tej strony.
          <h3>VIII. Zmiany w tej polityce</h3>W każdej chwili możemy wprowadzać
          zmiany w niniejszej polityce. Możesz zostać poproszony o sprawdzenie i
          ponowne zaakceptowanie informacji zawartych w tej polityce, jeśli
          zmienią się one w przyszłości.
          <h3>IX. Umowa dotycząca danych Steam</h3>
          Aby uzyskać dostęp do WildLandsRP, potrzebujesz obsługiwanego konta
          RedM i Steam oraz ważnej kopii Red Dead Redemption 2. Przyjmujesz do
          wiadomości i zgadzasz się, że WildLandsRP może w dowolnym momencie
          pobrać Twoje dane Steam. Zgadzasz również się, że te dane będą
          przechowywane i wykorzystywane z serwerów w Polsce.
        </div>
        <div className="grid-item"></div>
      </section>
      <Footer />
    </div>
  );
}

export default Policy;
